import { BASE_URL_V2_1 } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'CHAPTERS_GET',
  GET_SUCCESS: 'CHAPTERS_GET_SUCCESS',
  GET_FAILURE: 'CHAPTERS_GET_FAILURE',
  INVALIDATE_ITEM: 'CHAPTER_INVALIDATE_ITEM',
};

export const get = actions.get(
  (userId, { chapterId }) => `${BASE_URL_V2_1}/students/${userId}/chapters/${chapterId}/`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const invalidateItem =
  (id, { chapterId }) =>
  dispatch => {
    dispatch({
      type: ACTIONS.INVALIDATE_ITEM,
      payload: {
        id,
        chapterId,
      },
    });
  };
